<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Recherche de critère </div>
        <div class="modal-body">
            <div class="search">
                <frg-search-input (search)="onSearchCritere($event)"></frg-search-input>
            </div>
            <div class="table">
                <frg-table #table3 [keysBody]="criteresBodyTable" [keysColumn]="criteresColumnTable"
                    [isRowsClickable]="true" (onClickRow)="addRemoveFactor($event)">
                </frg-table>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeAddEditModal()" [backgroundColor]="'var(--darkest-primary)'"
                    [type]="'reset'">Quitter</frg-button>
                <frg-button [backgroundColor]="'var(--primary)'" [type]="'submit'" (click)="sendCriteres()">Valider
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>